module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/5_14acaf3c14fdb85c24ff41fc16c1ba92.png";